import React from "react";
import { useProgress, Html } from "@react-three/drei";

const Loader = () => {
  const { progress } = useProgress();
  return (
    <Html center>
      <div className="relative w-[100px] h-[45px] bg-white rounded-lg">
        <p className="absolute text-xs top-[10px] left-[10px]">Loading...</p>
        <div className="absolute left-[10px] bottom-[10px] h-[5px] bg-green-500"
            style={{
                width: `${progress/100 * 80}px`
            }}
        ></div>
      </div>
    </Html>
  );
};

export default Loader;
